'use client';

import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Confirmation_Message.css';

const Confirmation_Message = () => {
  const [timeLeft, setTimeLeft] = useState(293); // 4 mins 53 secs = 293 seconds
    const router = useNavigate();
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const secs = String(seconds % 60).padStart(2, '0');
    return { hrs, mins, secs };
  };

  const { hrs, mins, secs } = formatTime(timeLeft);

  return (
    <section className="confirmation-section">
      <p className="back_text" onClick={() => router('/')}>
        <FontAwesomeIcon icon={faArrowLeft} className="back_icon" /> Back to Home
      </p>

      <h2 className="confirmation-title">Congrats, you have taken the 1st step!</h2>
      <p className="confirmation-subtitle">
        We have received your query and have informed an expert. Our in-house Senior Counsellor will
        contact you soon!
      </p>
      <div className="timer-box">
        <p className="timer-label">We will call you in:</p>
        <div className="timer-values">
          <div className="time-unit">
            <span>{hrs}</span>
            <label>HRS</label>
          </div>
          <div className="time-unit">
            <span>{mins}</span>
            <label>MINS</label>
          </div>
          <div className="time-unit">
            <span>{secs}</span>
            <label>SECS</label>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Confirmation_Message;
